module.exports = __webpack_public_path__ + "img/90ef6b5.jpg";